import React from 'react';

import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const LazySpaceLegacyContentRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LegacyContentRouteComponent" */
				'./SpaceLegacyContentRouteComponent.tsx'
			)
		).SpaceLegacyContentRouteComponent,
});

export const LazySpaceLegacyContentRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			pageState: {
				spaceKey: any;
			};
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => {
	return <LazySpaceLegacyContentRouteComponent spaceKey={spaceKey} />;
};

LazySpaceLegacyContentRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		pageState: {
			spaceKey: any;
		};
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
	};
} => ({
	Screen: {
		pageState: { spaceKey },
		screenEvent: { name: 'legacyContentScreen' },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
	},
});
